module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEjSURBVHgB7dYxTsNAEIXhZ0NBaSrLHRewvXS03CB0lOYG4QSEEzhHgBMgOjqOkKRLmTJdcgI7b5RUkdKMZ60U80mrWKl+reXdAZxzzrkhEihVVdUmSdLwcc/flyUhghsolGU5SdN0zsc7rozrtSiKLa1gLIUCdyyc/ZX1ff/FXZ3CmCrwEoa3jPyAIdNAwciZZaR5oDhFtjAQJVAwclrX9U8IIcMA0QJPJvx4/odExg4UgZELbeQYgeKh67oGCmMFggf7DgpjBW64fqEwRuCSX/Qjr+o9FKIGMuyb61kbJ24RicQxrMFAsW6ST4s4EeMulrgZjJi+Ysa9M24OQ6od5Jl2Pj3LVP1mHSdUEzUn53We5/eMesLxGJGR/w/OOefc1TkAYAxL7htd3AUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/transaction/guide_arrow.png
// module id = wZNQ
// module chunks = 1